.playerPortfolioWrapper {
  --stackedHorizontalPositionAdjustment: calc(100% - 14px);

  /* TODO may or may not need this for v2 */
  pointer-events: auto;

  /* Helps separate players' cards from each other in >4 player count games */
  &.moreThanFourPlayers {
    background-color: var(--ds-poker-green-darkest);
    border-radius: 12px;
    margin: 12px 0;
    padding: 12px;

    &.stacked {
      min-height: 200px;
      min-width: 150px;
    }
    &.singleFile {
      min-height: 130px;
      min-width: 200px;
    }
  }

  &.singleFile {
    display: flex;
    flex-flow: row-reverse nowrap;
    align-items: flex-start;

    & .playerCashPileWrapper {
      margin-right: 8px;
    }
  }

  &.stacked {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    position: relative;

    & .playerCashPileWrapper {
      margin-top: 8px;
    }
  }
}

.gravatar {
  border-radius: 50%;
  margin-bottom: 6px;
}

.gravatarWrapper {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;

  padding-top: calc(176px / 2 - 32px / 2);
  width: 176px;
  height: 176px;
  border-radius: 50%;

  position: absolute;
}

.cardCount {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  & img {
    width: 14px;
    margin-right: 4px;
  }
}

.turnArcs {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
}

.turnArc {
  position: absolute;
  width: 100%;
}
.turnArc1 {
  transform: rotate(-90deg);
}
.turnArc2 {
  transform: rotate(-30deg);
}
.turnArc3 {
  transform: rotate(30deg);
}

@keyframes blink {
  0% {
    opacity: 10%;
  }
  49% {
    opacity: 10%;
  }
  50% {
    opacity: 100%;
  }
  100% {
    opacity: 100%;
  }
}

.turnArc.faded {
  opacity: 10%;

  &.blink {
    animation: blink 1.25s linear infinite;
  }
}

.gravatarWrapper.clickable,
.gravatarWrapper.isMyMinorTurn {
  background-color: rgba(76, 98, 82, 0.2);
  cursor: pointer;
}

.gravatarWrapper.clickable:hover,
.gravatarWrapper.selected,
.gravatarWrapper.isMyMajorTurn {
  background-color: rgba(76, 98, 82, 0.6);
}

.singleFileTop .gravatarWrapper {
  bottom: calc(100% - 16px);
  left: 50%;
  transform: translateX(-50%);
}

.singleFileBottom .gravatarWrapper {
  top: calc(100% - 16px);
  left: 50%;
  transform: translateX(-50%);
}

.singleFileBottom.isCurrentPlayer .gravatarWrapper {
  top: calc(100% - 56px);
}

.stackedStageLeft .gravatarWrapper {
  right: var(--stackedHorizontalPositionAdjustment);
  top: 50%;
  transform: translateY(-50%);
}

.stackedStageRight .gravatarWrapper {
  left: var(--stackedHorizontalPositionAdjustment);
  top: 50%;
  transform: translateY(-50%);
}

.stackedStageLeft .turnArcs {
  transform: rotate(-90deg);
}
.stackedStageRight .turnArcs {
  transform: rotate(-90deg) scaleY(-1);
}
.singleFileBottom .turnArcs {
  transform: scaleY(-1);
}

.playerNeighborhoodsWrapper {
  display: grid;
  grid-auto-columns: auto;
  grid-auto-flow: column;
  align-items: flex-start;

  &.singleFile {
    grid-template-rows: auto;
  }

  &.stacked {
    grid-template-rows: auto auto;
  }
}

.playerCashPileWrapper {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
}

.playerCashPileWrapper + .playerCashPileWrapper {
  margin-left: 8px;
}

.neighborhoodWrapper {
  position: relative;

  & .neighborhoodToggle {
    position: absolute;

    &.singleFile {
      bottom: calc(100% + 4px);
      left: 50%;
      transform: translateX(-50%);
    }

    &.stacked {
      right: calc(100% + 4px);
      top: 50%;
      transform: translateY(-50%);
    }

    &.hiddenToggle {
      display: none;
    }
  }
}

.cashPileWrapper {
  position: relative;
}

.cardImage {
  position: absolute;

  &:hover {
    z-index: 1;
  }

  &.clickable {
    cursor: pointer;
  }

  &.selected,
  &.highlighted {
    z-index: 2;
  }

  &.selected {
    border: 2px solid aqua;
  }

  &.faded,
  &.fadeUnclickable {
    filter: blur(0.6px) saturate(0.7) brightness(0.6);
  }
}

.portfolioInnerWrapper {
  position: relative;
}
